/**
 * Youtube video player with cover image
 */
export default class YoutubeVideoPlayer {
    constructor() {
        this.DOM = {
            youtubeVideoPlayer: ".js-youtube-video",
        };

        /**
         * Fetch doctors tabs HTML element
         * @type {Element}
         */
        this.youtubeVideoPlayer = document.querySelector(
            this.DOM.youtubeVideoPlayer,
        );
    }

    init() {
        if (this.youtubeVideoPlayer === null) {
            return;
        }
        this.youtubeVideoJS();
    }

    youtubeVideoJS() {
        let currentID = 100000000;
        const videoShareIframes = document.querySelectorAll(
            ".video-share iframe",
        );

        videoShareIframes.forEach(function (iframe) {
            iframe.id = currentID;
            iframe.src += "&autoplay=0&rel=0";
            currentID++;
        });

        let current = 100000000;
        const videoCovers = document.querySelectorAll(".video-cover.youtube");

        videoCovers.forEach(function (videoCover) {
            const findVideo = document.getElementById(current);

            videoCover.addEventListener("click", function () {
                videoCover.style.display = "none";
                findVideo.src = findVideo.src.replace(
                    "autoplay=0",
                    "autoplay=1",
                );
                findVideo.style.visibility = "visible";
                findVideo.style.width = "100%";
                findVideo.style.height = "100%";
            });

            current++;
        });

        const youtubeVideos = {};
        const youtubeIframes = document.querySelectorAll(
            ".video-cover.youtube ~ iframe",
        );

        youtubeIframes.forEach(function (iframe) {
            const id1 = iframe.id;
            youtubeVideos[id1] = iframe.src;
        });
    }
}
